window.loadScript = (src, async = true) => {
    let script = document.createElement("script");
    script.src = src;
    script.async = async;
    document.querySelector("head").append(script);
};
